module.exports = __webpack_public_path__ + "img/icon_sec6_05.ce8a178c.png";